<template lang="pug">
.u-margin-top-8x
  h3.p-title.p-title--icon {{$t('shared.risk_objects.generic.travel')}}
    Icon(icon="travel" classes="p-title__icon")
  Ownership(risk="travel" risk_object="cancellation")
  Ownership(risk="travel" risk_object="assistance")
  Ownership(risk="travel" risk_object="luggage")
</template>

<script>
import Icon from '../shared/Icon'
import Ownership from './Ownership'

export default {
  components: {
    Icon,
    Ownership
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurances/Travel.vue